import React, { useState } from "react";
import { ChevronUp, ChevronDown, ChevronLeft, ChevronRight } from "lucide-react";

// Minimalist TAB gold-and-white D-Pad, bottom-left, split-thumb ergonomics.
// Works with pointer (desktop/tablet/mobile). Drives avatar walk/crawl + aim.
export default function DPad({ onDir }) {
  const [runActive, setRunActive] = useState(false);
  const press = (dir) => (e) => { e.preventDefault(); onDir(dir, true); };
  const release = (dir) => (e) => { e.preventDefault(); onDir(dir, false); };

  const btn = (dir, Icon, style) => (
    <button
      data-testid={`dpad-${dir}`}
      onPointerDown={press(dir)}
      onPointerUp={release(dir)}
      onPointerLeave={release(dir)}
      onPointerCancel={release(dir)}
      style={{
        position: "absolute", width: 38, height: 38, display: "flex", alignItems: "center", justifyContent: "center",
        cursor: "pointer", touchAction: "none", userSelect: "none",
        background: "linear-gradient(180deg, rgba(255,255,255,0.95), rgba(201,162,75,0.85))",
        color: "#10120f", border: "1px solid rgba(255,255,255,0.7)",
        boxShadow: "0 4px 14px rgba(0,0,0,0.5)", ...style,
      }}
    >
      <Icon size={18} strokeWidth={2.4} />
    </button>
  );

  return (
    <div data-testid="dpad-control" className="dpad-scale" style={{ position: "relative", width: 120, height: 120, pointerEvents: "auto" }}>
      {/* center hub doubles as a hold-to-RUN control */}
      <button
        data-testid="dpad-run"
        aria-pressed={runActive}
        onPointerDown={(e) => { setRunActive(true); press("run")(e); }}
        onPointerUp={(e) => { setRunActive(false); release("run")(e); }}
        onPointerLeave={(e) => { setRunActive(false); release("run")(e); }}
        onPointerCancel={(e) => { setRunActive(false); release("run")(e); }}
        style={{ position: "absolute", left: 41, top: 41, width: 38, height: 38, borderRadius: 8, background: runActive ? "rgba(201,162,75,0.35)" : "rgba(13,14,17,0.7)", border: `1px solid ${runActive ? "#f2c85b" : "rgba(201,162,75,0.5)"}`, boxShadow: runActive ? "0 0 12px rgba(242,200,91,0.6)" : "none", color: runActive ? "#fff2cf" : "#c9a24b", fontSize: 7, fontWeight: 700, letterSpacing: "0.06em", cursor: "pointer", touchAction: "none", userSelect: "none", transition: "background-color 0.12s ease, box-shadow 0.12s ease, border-color 0.12s ease" }}
      >
        RUN
      </button>      {btn("up", ChevronUp, { left: 41, top: 4, borderRadius: "10px 10px 4px 4px" })}
      {btn("down", ChevronDown, { left: 41, top: 78, borderRadius: "4px 4px 10px 10px" })}
      {btn("left", ChevronLeft, { left: 4, top: 41, borderRadius: "10px 4px 4px 10px" })}
      {btn("right", ChevronRight, { left: 78, top: 41, borderRadius: "4px 10px 10px 4px" })}
      <div style={{ position: "absolute", left: 0, top: 124, fontSize: 8.5, letterSpacing: "0.14em", textTransform: "uppercase", color: "#c9a24b", width: 120, textAlign: "center" }}>
        Memorial Pace
      </div>
    </div>
  );
}
